var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
function BitBuffer() {
  (this || _global).buffer = [];
  (this || _global).length = 0;
}
BitBuffer.prototype = {
  get: function (index) {
    const bufIndex = Math.floor(index / 8);
    return ((this || _global).buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
  },
  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit((num >>> length - i - 1 & 1) === 1);
    }
  },
  getLengthInBits: function () {
    return (this || _global).length;
  },
  putBit: function (bit) {
    const bufIndex = Math.floor((this || _global).length / 8);
    if ((this || _global).buffer.length <= bufIndex) {
      (this || _global).buffer.push(0);
    }
    if (bit) {
      (this || _global).buffer[bufIndex] |= 128 >>> (this || _global).length % 8;
    }
    (this || _global).length++;
  }
};
exports = BitBuffer;
export default exports;